import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled", "placeholder", "rows", "spellcheck", "maxlength", "minlength", "required"]
const _hoisted_2 = {
  key: 0,
  class: "custom icon"
}
const _hoisted_3 = {
  key: 1,
  class: "footer"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Footnote = _resolveComponent("Footnote")
  const _component_SymbolCounter = _resolveComponent("SymbolCounter")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input right custom-textarea", {disabled: $props.disabled, icon: !!_ctx.$slots.custom_icon}])
  }, [
    _withDirectives(_createElementVNode("textarea", {
      ref: "textarea",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      class: _normalizeClass({invalid: !$data.valid}),
      disabled: $props.disabled,
      placeholder: $props.placeholder,
      rows: $options.c_rows,
      spellcheck: $props.spellcheck,
      maxlength: $props.type === 'textarea-kb' ? undefined : $props.maxlength,
      minlength: $props.type === 'textarea-kb' ? undefined : $props.minlength,
      required: $props.required,
      onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.onInput && _ctx.onInput(...args))),
      onBlur: _cache[2] || (_cache[2] = $event => (_ctx.$emit('blur', this)))
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1), [
      [_vModelText, _ctx.value]
    ]),
    (_ctx.$slots.custom_icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "custom_icon", {}, undefined, true)
        ]))
      : _createCommentVNode("v-if", true),
    ($props.footnote)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          ($options.has_validation || $options.error_text || $props.description.length > 0)
            ? (_openBlock(), _createBlock(_component_Footnote, {
                key: 0,
                type: $data.valid ? 'default' : 'error'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($data.valid ? $props.description : $options.error_text), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["type"]))
            : _createCommentVNode("v-if", true),
          ($props.maxlength > 0 && $options.c_counter)
            ? (_openBlock(), _createBlock(_component_SymbolCounter, {
                key: 1,
                current: $options.counter_value,
                unit: $props.type === 'textarea-kb' ? 'KB' : '',
                maxlength: $props.maxlength
              }, null, 8 /* PROPS */, ["current", "unit", "maxlength"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}